import { apiConstants } from '../../apiConstant'
import { formDataCommonFunction } from '../../serviceCall'

export const getProjectsApi = (data, callback, errorCallBack) => {
    return async (dispatch) => {
        formDataCommonFunction(data, apiConstants.TICKET.GET_PROJECTS)
            .then((response) => {
                callback && callback(response)
            })
            .catch((error) => {
                errorCallBack && errorCallBack(error.response)
            })
    }
} 
